<template lang="pug">
.wrapper-pegaponto-details
  h2 {{ id ? `editar`: 'novo' }} pega ponto

  .form-new
    Validate.name(v-model="pegaponto.name" :minLength="3")
      PTextField(label="descrição" v-focus)

    .reps
      PMultiSelect(v-model="pegaponto.reps" useCommon="reps" labelItem="name" title="selecione os REPs deste dispositivo")

    .button
      PButton(
      color="danger"
      size="md"
      @click="goBack"
      block
      )
        | voltar
      PButton(
      color="success"
      size="md"
        @click="save"
          :loading="saving"
      block
      )
        | salvar

</template>

<script>
import { useValidationsMixin } from 'src/common/validations'
export default {
  name: 'PegaPontoDetails',
  props: {
    id: {type: String, required: false, default: null}
  },
  mixins: [useValidationsMixin({deepCheck: true})],
  data () {
    return {
      saving: false,
      fields: null,
      pegaponto: {
        id: null,
        name: '',
        activation_code: '',
        companies: {selected: []},
        reps: {selected: []}
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push('/rep')
    },
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }
      this.saving = true

      try {
        if (this.pegaponto.reps.selected.length === 0) {
          this.$swal({
            type: 'warning',
            text: 'Selecione pelo menos 1 REP'
          })
          this.saving = false
          return
        }

        const data = {
          name: this.pegaponto.name,
          comp_man: this.$store.state.userInfo.compMan.id,
          companies: this.pegaponto.companies.selected.map(item => item.id),
          reps: this.pegaponto.reps.selected.map(item => item.id)
        }
        await this.$API.pegaponto.save(data)
        this.$router.push('/rep')
      } catch (e) {
        console.error(e)
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possível salvar o dispositivo'
        })
      }
      this.saving = false
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper-pegaponto-details {
  display: grid;
  grid-template-rows: min-content auto;
  grid-template-columns: 1fr;

  h2 {
    text-align: center;
  }

  .form-new {
    grid-row: 2;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr min-content;
    grid-column-gap: 30px;
    grid-row-gap: 20px;
    align-items: center;
    grid-template-areas:
      "name reps"
      ". button";

    .name { grid-area: name }
    .reps { grid-area: reps }
    .button {
      grid-area: button;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
      padding-left:70px;
    }
  }
}
</style>
